module.exports = __webpack_public_path__ + "static/media/webmotors.d6f54487.png";